import { isEqual } from 'lodash';
import { SCREEN_TYPE } from '../constants';

export const TABLE_MIN_WIDTH = 768;
export const SMALL_DESKTOP_MIN_WIDTH = 1024;
export const DESKTOP_MIN_WIDTH = 1200;

export type ScreenType = 'desktop' | 'smallDesktop' | 'tablet' | 'mobile';

export function parseScreenType(): ScreenType {
  if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
    return SCREEN_TYPE.desktop;
  } else if (
    window.innerWidth >= SMALL_DESKTOP_MIN_WIDTH &&
    window.innerWidth < DESKTOP_MIN_WIDTH
  ) {
    return SCREEN_TYPE.smallDesktop;
  } else if (
    window.innerWidth >= TABLE_MIN_WIDTH &&
    window.innerWidth < SMALL_DESKTOP_MIN_WIDTH
  ) {
    return SCREEN_TYPE.tablet;
  } else {
    return SCREEN_TYPE.mobile;
  }
}

export function isDesktop(screenType: string) {
  return (
    isEqual(screenType, SCREEN_TYPE.desktop) ||
    isEqual(screenType, SCREEN_TYPE.smallDesktop)
  );
}

export function isMobile(screenType: string) {
  return isEqual(screenType, SCREEN_TYPE.mobile);
}

export function isTablet(screenType: string) {
  return isEqual(screenType, SCREEN_TYPE.tablet);
}

export function isDevice(screenType: string) {
  return isTablet(screenType) || isMobile(screenType);
}
